<template>
  <div class="app-single-topup-amount-selector">
    <slot name="txtBefore">
      <h2>Direkte Aufladung online</h2>
      <p>Sie können Ihr Guthabenkonto auch einmalig aufladen.</p>
    </slot>
    <b-form>
      <b-form-group>
        <b-form-row>
          <b-col cols="12" md="">
            <label for="inputAmount"><slot name="lblAmount">Betrag in Euro</slot></label>
          </b-col>
          <b-col>
            <b-select
              name="amount"
              required
              v-model="amount"
              :options="availableAmounts"
            ></b-select>
          </b-col>
        </b-form-row>
      </b-form-group>
      <Stepper
        :show-prev="false"
        @next="next()"
      >
        <template #btnPrev><slot name="btnPrev"></slot></template>
        <template #btnNext><slot name="btnNext"></slot></template>
      </Stepper>
    </b-form>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import processSteps from '../../../../../mixins/processSteps'
import preFilledInput from '../../../../../mixins/preFilledInput'
import Stepper from '../../../../generic/Stepper.vue'
import { mapMutations } from 'vuex'
import price from '@/mixins/price'

export const stepName = 'amountSelect'

export default {
  name: 'SingleTopUpAmountSelector',
  components: { Stepper },
  mixins: [
    processSteps(stepName, stepName, stepName),
    preFilledInput('amount', 'defaultAmount'),
    price
  ],
  methods: {
    ...mapMutations('topUp/single', [
      'changeStep'
    ]),
    next () {
      this.changeStep({ step: this.nextStep, amount: this.amount })
    }
  },
  computed: {
    availableAmounts: function () {
      return this.amounts.map(cents => {
        return {
          value: cents,
          text: this.price(cents)
        }
      })
    }
  },
  props: {
    amounts: {
      type: Array,
      required: true
    },
    defaultAmount: {
      type: Number,
      default: 1000
    }
  }
}
</script>
